<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container :style="cssProps">
        <h1 class="titulo mb-5">Política de Vendas</h1>
        <div class="v-card card-container">
            <stepper-politica-vendas :pagina="1" class="mb-3"></stepper-politica-vendas>
            <h2 class="mb-2">Selecione uma categoria abaixo:</h2>
            <m-swiper :data="modalidades" :focused-item="item_da_reserva_para_ser_focado">
                <template v-slot:default="props">
                    <div :class="{ 'card-produto': true, 'card-selecionado': props.index === modalidade_selecionada_index }">
                        <card-produto :icone="props.item.icone" :identificador-produto="props.index" :modalidade="props.item.modalidade"
                                      :nome="props.item.nome" @onSelecionarProduto="selecionarModalidade" />
                    </div>
                </template>
            </m-swiper>
            <v-form ref="formPoliticaVenda" @submit.prevent="abrirAbaBens" v-if="tem_modalidade_selecionada">
                <v-layout class="justify-center mt-5">
                    <v-col cols="12" md="4">
                        <Autocomplete label="Grupo:" id="FieldGrupo" :items="grupos" v-input-filter="[$filters.numeric]"
                                      v-model="filtro.id_grupo" item-text="cd_grupo" type="number" item-value="id_grupo"
                                      placeholder="Selecione o grupo"
                                      :rules="[$rules.required]"
                                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                      maxlength="8" class="col-md-4" />
                    </v-col>
                    <v-col cols="12" md="4">
                        <Autocomplete label="Plano de venda:" id="FieldPlanoVenda" :items="planos_venda"
                                      v-input-filter="[$filters.numeric]" v-model="filtro.id_plano_venda" item-text="cd_nm_plano_venda"
                                      :rules="[$rules.required]"
                                      item-value="id_plano_venda" placeholder="Selecione o plano de venda" maxlength="30" class="col-md-4" />
                    </v-col>
                    <v-btn color="primary" class="label-margin" @click="abrirAbaBens">Selecionar Bem</v-btn>
                </v-layout>
            </v-form>
            <v-row class="justify-center bem-selecionado" v-if="bem_selecionado">
                <v-col cols="12" md="4">
                    <img class="bem-selecionado-img" :src="`${ws}/compra/imagembem/${bem_selecionado.id_bem}`"
                         :alt="bem_selecionado.nm_bem">
                </v-col>
                <v-col cols="12" md="4" class="d-flex bem-infos">
                    <h3>Bem Selecionado:</h3>
                    <h2 style="color: #222222; font-weight: bold">Cód {{ bem_selecionado.cd_bem }}</h2>
                    <h4 class="nome-bem">{{ bem_selecionado.nm_bem }}</h4>
                    <h4 class="valor-bem">{{ bem_selecionado.vl_bem | money }}</h4>
                </v-col>
                <v-col cols="12" md="3">
                    <a @click="bem_selecionado = null">
                        <v-icon color="primary">mdi-close</v-icon> Remover
                    </a>
                </v-col>
            </v-row>
        </div>

        <div v-if="tem_modalidade_selecionada" class="mt-5">
            <v-layout class="justify-space-between my-3">
                <v-btn color="primary" class="label-margin" @click="abrirFiltro">
                    <v-icon color="lightgray">rod-filter</v-icon> Filtros
                </v-btn>
                <v-btn color="primary" class="label-margin" @click="aba_visualizacao_visivel = true">
                    <v-icon color="lightgray">visibility</v-icon> Alterar Visualização
                </v-btn>
            </v-layout>
            <DataTable dense url="/politica_vendas" ref="datatable" @onLoad="itensCarregados" @rowSelected="handleRowSelected"
                       :overflow-y-visible="true" :overflow-x-scroll-visible="true" class="table-politica-vendas table-container"
                       colored-row :params="params" :filter="filter" :headers-length="15"
                       no-data-text="Nenhum registro encontrado para as condições selecionadas.">
                <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr class="header-line-fixed">
                            <th class="fixed-column-table-head" style="left:0rem" ref="fixedColumn"
                                v-resize="ajustarTamanhosResponsivos">
                                <div class='d-flex'>
                                    <div class="mr-10 pr-2" style="width: 50px;">
                                        Grupo
                                    </div>
                                    <div class="coluna-plano-venda">
                                        Plano de venda
                                    </div>
                                </div>
                            </th>
                            <th v-if="campos_usuario.num_maximo_cotas">Máx. Cotas</th>
                            <th v-if="campos_usuario.vagas">Vagas</th>
                            <th style="padding: 10px 0;">
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-center">
                                        <span class="text-center ml-2">PRAZOS</span>
                                        <v-tooltip bottom color="white">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <div class="d-flex">
                                                        <v-icon size="18" class="ml-2" color="primary">mdi-help-box</v-icon>
                                                    </div>
                                                </span>
                                            </template>
                                            <div style="max-width: 300px;color:#222">
                                                <p class="mb-2 mt-1" style="line-height:18px">
                                                    <span class="prazo-sim mb-1 mr-1">11,99%:</span> A
                                                    porcentagem indica que o prazo está disponível para o grupo e a taxa de administração praticada.
                                                </p>
                                                <p class="mb-3 mt-1" style="line-height:10px">
                                                    <v-icon class="pb-1" size="24" color="error">
                                                        mdi-close
                                                    </v-icon> Este ícone indica que o prazo não está disponível no grupo.
                                                </p>
                                                <p class="mb-1 mt-1" style="line-height:10px">
                                                    <v-icon class="pb-1" size="24" color="#b2b2b2">
                                                        mdi-minus-box-outline
                                                    </v-icon> Este ícone indica que não existe o prazo para o
                                                    grupo.
                                                </p>
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div class="d-flex" v-if="politica_vendas.length > 0">
                                        <p class="prazo-header sub-header flex text-center flex-basis-0" v-for="prazo in prazos" :key="prazo">
                                            {{ prazo }}
                                        </p>
                                    </div>
                                </div>
                            </th>
                            <th v-if="campos_usuario.assembleias_realizadas">Assembleias <br> Realizadas</th>
                            <th v-if="campos_usuario.credito_menor">Crédito Menor</th>
                            <th v-if="campos_usuario.credito_maior">Crédito Maior</th>
                            <th v-if="campos_usuario.categoria">Categoria <br> Plano de Venda</th>
                            <th v-if="campos_usuario.lc_embutido">Lance embutido</th>
                            <th v-if="campos_usuario.lc_parcelado">Lance parcelado</th>
                            <th v-if="campos_usuario.md_contemplacao">Média de contemplações por lance</th>
                            <th v-if="exibir_colunas_calculo_lance">
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-center">
                                        <span class="text-center ml-2">Lance dos últimos 3 meses</span>
                                        <v-tooltip bottom color="white">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <div class="d-flex">
                                                        <v-icon size="18" class="ml-2" color="primary">mdi-help-box</v-icon>
                                                    </div>
                                                </span>
                                            </template>
                                            <div style="color:#222">
                                                Valores exibidos baseados em lance livre e lance vinculado.
                                            </div>
                                        </v-tooltip>
                                    </div>
                                    <div class="d-flex">
                                        <p class="sub-header flex text-center flex-basis-0 mx-2" v-if="campos_usuario.lance_01">
                                            Último menor
                                            lance
                                        </p>
                                        <p class="sub-header flex text-center flex-basis-0 mx-2" v-if="campos_usuario.lance_02">
                                            Penúltimo
                                            menor lance
                                        </p>
                                        <p class="sub-header flex text-center flex-basis-0 mx-2" v-if="campos_usuario.lance_03">
                                            Antepenúltimo
                                            menor lance
                                        </p>
                                        <p class="sub-header flex text-center flex-basis-0 mx-2" v-if="campos_usuario.lance_total">
                                            Média de
                                            lance total
                                        </p>
                                    </div>
                                </div>
                            </th>
                            <th v-if="exibir_colunas_diluicao_lance">
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-center">
                                        <span class="text-center">DILUIÇÃO DE LANCE</span>
                                    </div>
                                    <div class="d-flex">
                                        <p class="sub-header flex text-center flex-basis-0 mx-2" v-if="campos_usuario.lance_fixo">Fixo</p>
                                        <p class="sub-header flex text-center flex-basis-0 mx-2" v-if="campos_usuario.lance_livre">Livre</p>
                                    </div>
                                </div>
                            </th>
                            <th v-if="campos_usuario.aumento_credito">Aumento de Crédito</th>
                        </tr>
                    </thead>
                </template>

                <template v-slot:items="{ item: condicao_venda }">
                    <td class="fixed-column" style="left:0rem;">
                        <div class='d-flex'>
                            <div class="mr-10 pr-2" style="width: 50px;">
                                <v-tooltip bottom color="white" v-if="condicao_venda.grupo_pontual">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <div class="d-flex">
                                                <v-icon size="16" color="primary" style="margin-right: 2px">mdi-star</v-icon>
                                                <p class="mb-0">{{ condicao_venda.cd_grupo }}</p>
                                            </div>
                                        </span>
                                    </template>
                                    <p class="mb-0" style="color:#222">Grupo pontual</p>
                                </v-tooltip>
                                <v-tooltip bottom color="white" class="d-flex align-center" v-else-if="condicao_venda.grupo_praja">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <div class="d-flex">
                                                <v-icon size="16" color="primary" style="margin-right: 2px">mdi-clock-fast</v-icon>
                                                <p class="mb-0">{{ condicao_venda.cd_grupo }}</p>
                                            </div>
                                        </span>
                                    </template>
                                    <p class="mb-0" style="color:#222">Grupo Pra Já</p>
                                </v-tooltip>
                                <v-tooltip bottom color="white" class="d-flex align-center" v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <div class="d-flex">
                                                <v-icon size="16" color="primary" style="margin-right: 2px">mdi-check-circle-outline</v-icon>
                                                <p class="mb-0">{{ condicao_venda.cd_grupo }}</p>
                                            </div>
                                        </span>
                                    </template>
                                    <p class="mb-0" style="color:#222">Grupo Convencional</p>
                                </v-tooltip>
                            </div>
                            <div>
                                {{ condicao_venda.cd_plano_venda + ' - ' +
                                    condicao_venda.nm_plano_venda }}
                            </div>
                        </div>
                    </td>
                    <td v-if="campos_usuario.num_maximo_cotas" class="text-center">{{ condicao_venda.num_maximo_cotas }}</td>
                    <td v-if="campos_usuario.vagas" class="text-center">{{ condicao_venda.vagas }}</td>
                    <td>
                        <v-row>
                            <v-flex :class="{ 'text-center': true, 'flex-basis-0': true }" v-for="(prazo) in prazos" :key="prazo">
                                <span v-if="getFuroDoPrazoOuRetornaTraco(condicao_venda.prazos, prazo) === '-'">
                                    <v-tooltip bottom color="white">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <iconNotFound />
                                            </span>
                                        </template>
                                        <span style="color:#222">Prazo inexistente no grupo</span>
                                    </v-tooltip>
                                </span>
                                <span v-else-if="String(getFuroDoPrazoOuRetornaTraco(condicao_venda.prazos, prazo)).toUpperCase() === 'NÃO'">
                                    <v-tooltip bottom color="white">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on"><v-icon size="24" color="error">mdi-close</v-icon></span>
                                        </template>
                                        <span style="color:#222">Prazo indisponível para o grupo</span>
                                    </v-tooltip>

                                </span>
                                <span class="prazo-sim" v-else-if="getFuroDoPrazoOuRetornaTraco(condicao_venda.prazos, prazo) > 0">
                                    <v-tooltip bottom color="white">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">{{ pegaNumeroAteSegundaVirgula(getFuroDoPrazoOuRetornaTraco(condicao_venda.prazos, prazo )) | percentage }}</span>
                                        </template>
                                        <span style="color:#222">Taxa de administração para o grupo e prazo</span>
                                    </v-tooltip>

                                </span>
                                <span class="prazo-sim" v-else>
                                    <v-tooltip bottom color="white">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <iconNotFound />
                                            </span>
                                        </template>
                                        <span style="color:#222">Prazo inexistente no grupo</span>
                                    </v-tooltip>
                                </span>
                            </v-flex>
                        </v-row>
                    </td>
                    <td v-if="campos_usuario.assembleias_realizadas" class="text-center">
                        <v-tooltip
                                v-if='trazerAssembleiasRealizadas(condicao_venda.st_situacao, condicao_venda.assembleias_realizadas) == null'
                                bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on"><u>N/A</u></span>
                            </template>
                            <span>O grupo está em formação e portanto não há assembleias corridas ou parcelas anteriores acumuladas
                                (furo), não existindo portanto a negociação delas</span>
                        </v-tooltip>
                        <span v-else>{{ condicao_venda.assembleias_realizadas }}</span>
                    </td>

                    <td v-if="campos_usuario.credito_menor">{{ condicao_venda.credito_menor | money }}</td>
                    <td v-if="campos_usuario.credito_maior">{{ condicao_venda.credito_maior | money }}</td>
                    <td v-if="campos_usuario.categoria" class="text-center">{{ condicao_venda.categoria }}</td>
                    <td v-if="campos_usuario.lc_embutido" class="text-center">
                        <span v-if="condicao_venda.lc_embutido === null">
                            <iconNotFound />
                        </span>
                        <span v-else>
                            {{ `${parseInt(condicao_venda.lc_embutido)}%` }}
                        </span>
                    </td>
                    <td v-if="campos_usuario.lc_parcelado" class="text-center">
                        <span v-if="!condicao_venda.lc_parcelado">
                            <iconNotFound />
                        </span>
                        <span v-else>
                            <span>{{ condicao_venda.lc_parcelado }}</span><br>
                            <span>parcelas</span>
                        </span>
                    </td>
                    <td v-if="campos_usuario.md_contemplacao" class="text-center">
                        <span v-if="!condicao_venda.md_contemplacao">
                            <iconNotFound />
                        </span>
                        <span v-else>
                            {{ condicao_venda.md_contemplacao }}
                        </span>
                    </td>
                    <td v-if="campos_usuario.lance_01 || campos_usuario.lance_02 || campos_usuario.lance_03 || campos_usuario.lance_total">
                        <div class="d-flex">
                            <div v-if="campos_usuario.lance_01" class="text-center sub-header flex text-center flex-basis-0 mx-2">
                                <p class="td-spacer mb-0 mx-2">Último menor lance</p>
                                {{ pegaNumeroAteSegundaVirgula(condicao_venda.lance_01) | percentage }}
                            </div>
                            <div v-if="campos_usuario.lance_02" class="text-center sub-header flex text-center flex-basis-0 mx-2">
                                <p class="td-spacer mb-0 mx-2">Penúltimo menor lance</p>
                                {{ pegaNumeroAteSegundaVirgula(condicao_venda.lance_02) | percentage }}
                            </div>
                            <div v-if="campos_usuario.lance_03" class="text-center sub-header flex text-center flex-basis-0 mx-2">
                                <p class="td-spacer mb-0 mx-2">Antepenúltimo menor lance</p>

                                {{ pegaNumeroAteSegundaVirgula(condicao_venda.lance_03) | percentage }}
                            </div>
                            <div v-if="campos_usuario.lance_total" class="text-center sub-header flex text-center flex-basis-0 mx-2">
                                <p class="td-spacer mb-0 mx-2">Média de lance total</p>
                                {{ pegaNumeroAteSegundaVirgula(calcularMediaLance(condicao_venda.lance_01, condicao_venda.lance_02, condicao_venda.lance_03)) | percentage }}
                            </div>
                        </div>
                    </td>
                    <td v-if="campos_usuario.lance_fixo || campos_usuario.lance_livre">
                        <div class="d-flex">
                            <div v-if="campos_usuario.lance_fixo" class="text-center">
                                <p class="td-spacer mb-0 mx-2">Penúltimo menor lance</p>
                                <span v-if="!condicao_venda.dil_lance_fixo">
                                    <iconNotFound />
                                </span>
                                <span v-else>
                                    {{ condicao_venda.dil_lance_fixo | percentage }}
                                </span>
                            </div>
                            <div v-if="campos_usuario.lance_livre" class="text-center">
                                <p class="td-spacer mb-0 mx-2">Último menor lance</p>
                                <span v-if="!condicao_venda.dil_lance_livre">
                                    <iconNotFound />
                                </span>
                                <span v-else>
                                    {{ condicao_venda.dil_lance_livre | percentage }}
                                </span>
                            </div>
                        </div>
                    </td>
                    <td v-if="campos_usuario.aumento_credito" class="text-center">
                        <span v-if="condicao_venda.aumento_credito === null">
                            <iconNotFound />
                        </span>
                        <span v-else>
                            <v-tooltip bottom color="white">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on"><v-icon size="24"
                                                                           :color="condicao_venda.aumento_credito ? 'secondary' : 'error'">{{
                                                                               condicao_venda.aumento_credito ? 'mdi-check' : 'mdi-close' }}</v-icon></span>
                                </template>
                                <span style="color:#222">{{ condicao_venda.aumento_credito ? 'Disponível' : 'Indisponível'
                                }}</span>
                            </v-tooltip>

                        </span>
                    </td>
                </template>
            </DataTable>
        </div>

        <TabDialog ref="TabDialog" title="Selecionar Bem" v-model="aba_bem_visivel">
            <m-text-field v-model="filtro_bens.texto" label="Código ou nome do bem:" outlined />
            <v-row class="align-center">
                <v-col>
                    <MoneyTextField v-model="filtro_bens.vl_bem_min" label="Valor do bem:" placeholder="Valor mínimo" outlined />
                </v-col>
                <p class="mb-0">a</p>
                <v-col>
                    <MoneyTextField v-model="filtro_bens.vl_bem_max" placeholder="Valor máximo" outlined />
                </v-col>
            </v-row>
            <v-row class="mb-4 align-center">
                <v-flex class="col flex-basis-0">
                    <v-btn color="secondary" block @click="limparFiltroBens">Limpar Filtros</v-btn>
                </v-flex>
                <v-flex class="col flex-basis-0">
                    <v-btn color="primary" block @click="abrirAbaBens">Filtrar</v-btn>
                </v-flex>
            </v-row>
            <v-flex class="flex-basis-0" v-if="bens.length > 0">
                <v-row class="bem-item transition" v-for="bem in bens" :key="bem.id_bem" @click="selecionarBem(bem)">
                    <div class="img-bem">
                        <img :src="`${ws}/compra/imagembem/${bem.id_bem}`" :alt="bem.nm_bem" />
                    </div>
                    <v-col class="d-flex justify-space-between" style="flex-direction: column;">
                        <h2 style="color: #222222; font-weight: bold">Cód {{ bem.cd_bem }}</h2>
                        <h3>{{ bem.nm_bem }}</h3>
                        <h4>{{ bem.vl_bem | money }}</h4>
                    </v-col>
                </v-row>
            </v-flex>
            <p class="text-center" v-else>Nenhum bem encontrado</p>
        </TabDialog>
        <TabDialog title="Filtros" v-model="aba_filtro_visivel">
            <v-row class="align-center">
                <v-col>
                    <MoneyTextField label="Valor da parcela:" placeholder="Valor mínimo"
                                    v-model="filtro_detalhado.range_valor_parcela[0]" maxlength="11" outlined />
                </v-col>
                <p class="mb-0">a</p>
                <v-col>
                    <MoneyTextField placeholder="Valor máximo" v-model="filtro_detalhado.range_valor_parcela[1]" maxlength="11"
                                    outlined />
                </v-col>
            </v-row>
            <v-row class="align-center">
                <v-col>
                    <MoneyTextField label="Valor do crédito:" placeholder="Valor mínimo"
                                    v-model="filtro_detalhado.range_valor_credito[0]" maxlength="11" outlined />
                </v-col>
                <p class="mb-0">a</p>
                <v-col>
                    <MoneyTextField placeholder="Valor máximo" v-model="filtro_detalhado.range_valor_credito[1]" maxlength="11"
                                    outlined />
                </v-col>
            </v-row>

            <v-select v-if="tem_modalidade_selecionada && modalidade_selecionada.produtos.length > 1"
                      :items="[{ id_produto: null, nome_produto: 'TODOS' }, ...modalidade_selecionada.produtos]"
                      item-text="nome_produto" item-value="id_produto" v-model="filtro_detalhado.id_produto" outlined label="Produtos: "
                      placeholder="Selecione o produto" />
            <v-select id="FieldTipoGrupo" label="Tipo do grupo: " outlined v-model="filtro_detalhado.tipo_grupo"
                      placeholder="Selecione o tipo do grupo" :items="tipos_grupos" item-text="name" item-value="value" />
            <br>
            <p class="text--darkgray">Prazo de comercialização</p>
            <v-range-slider v-model="filtro_detalhado.range_prazos" :min="limites_filtro.min_prazos"
                            :max="limites_filtro.max_prazos" :step="1" color="secondary" track-color="gray" track-fill-color="secondary">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">{{ limites_filtro.min_prazos }}</p>
                <p style="width: 20px">{{ limites_filtro.max_prazos }}</p>
            </div>
            <p class="text--darkgray">Assembleias realizadas</p>
            <v-range-slider v-model="filtro_detalhado.range_assembleias" :min="limites_filtro.min_assembleias_realizadas"
                            :max="limites_filtro.max_assembleias_realizadas" :step="1" color="secondary" track-color="gray"
                            track-fill-color="secondary">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">{{ limites_filtro.min_assembleias_realizadas }}</p>
                <p style="width: 20px">{{ limites_filtro.max_assembleias_realizadas }}</p>
            </div>

            <p class="text--darkgray">Lance Embutido</p>
            <v-range-slider v-model="filtro_detalhado.range_lc_embutido" :min="limites_filtro.min_lc_embutido"
                            :max="limites_filtro.max_lc_embutido" :step="1" color="secondary" track-color="gray" track-fill-color="secondary"
                            :disabled="limites_filtro.min_lc_embutido === null || limites_filtro.max_lc_embutido === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}%</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">
                    {{ limites_filtro.min_lc_embutido !== null ? `${limites_filtro.min_lc_embutido}%` : '-' }}
                </p>
                <p style="width: 20px">
                    {{ limites_filtro.max_lc_embutido !== null ? `${limites_filtro.max_lc_embutido}%` : '-' }}
                </p>
            </div>
            <p class="text--darkgray">Lance Parcelado</p>
            <v-range-slider v-model="filtro_detalhado.range_lc_parcelado" :min="limites_filtro.min_lc_parcelado"
                            :max="limites_filtro.max_lc_parcelado" :step="1" color="secondary" track-color="gray" track-fill-color="secondary"
                            :disabled="limites_filtro.min_lc_parcelado === null || limites_filtro.max_lc_parcelado === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">
                    {{ limites_filtro.min_lc_parcelado !== null ? `${limites_filtro.min_lc_parcelado}` : '-' }}
                </p>
                <p style="width: 20px">
                    {{ limites_filtro.max_lc_parcelado !== null ? `${limites_filtro.max_lc_parcelado}` : '-' }}
                </p>
            </div>
            <p class="text--darkgray">Média Contemplações por lance</p>
            <v-range-slider v-model="filtro_detalhado.range_md_contemplacao" :min="limites_filtro.min_md_contemplacao"
                            :max="limites_filtro.max_md_contemplacao" :step="1" color="secondary" track-color="gray"
                            track-fill-color="secondary"
                            :disabled="limites_filtro.min_md_contemplacao === null || limites_filtro.max_md_contemplacao === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">
                    {{ limites_filtro.min_md_contemplacao !== null ? `${limites_filtro.min_md_contemplacao}` :
                        '-' }}
                </p>
                <p style="width: 20px">
                    {{ limites_filtro.max_md_contemplacao !== null ? `${limites_filtro.max_md_contemplacao}` :
                        '-' }}
                </p>
            </div>
            <p class="text--darkgray">Último menor lance</p>
            <v-range-slider v-model="filtro_detalhado.range_lance_01" :min="limites_filtro.min_lance_01"
                            :max="limites_filtro.max_lance_01" :step="1" color="secondary" track-color="gray" track-fill-color="secondary"
                            :disabled="limites_filtro.min_lance_01 === null || limites_filtro.max_lance_01 === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}%</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">{{ limites_filtro.min_lance_01 !== null ? `${limites_filtro.min_lance_01}%` : '-' }}</p>
                <p style="width: 20px">{{ limites_filtro.max_lance_01 !== null ? `${limites_filtro.max_lance_01}%` : '-' }}</p>
            </div>
            <p class="text--darkgray">Penúltimo menor lance</p>
            <v-range-slider v-model="filtro_detalhado.range_lance_02" :min="limites_filtro.min_lance_02"
                            :max="limites_filtro.max_lance_02" :step="1" color="secondary" track-color="gray" track-fill-color="secondary"
                            :disabled="limites_filtro.min_lance_02 === null || limites_filtro.max_lance_02 === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}%</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">{{ limites_filtro.min_lance_02 !== null ? `${limites_filtro.min_lance_02}%` : '-' }}</p>
                <p style="width: 20px">{{ limites_filtro.max_lance_02 !== null ? `${limites_filtro.max_lance_02}%` : '-' }}</p>
            </div>
            <p class="text--darkgray">Antepenúltimo menor lance</p>
            <v-range-slider v-model="filtro_detalhado.range_lance_03" :min="limites_filtro.min_lance_03"
                            :max="limites_filtro.max_lance_03" :step="1" color="secondary" track-color="gray" track-fill-color="secondary"
                            :disabled="limites_filtro.min_lance_03 === null || limites_filtro.max_lance_03 === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}%</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">{{ limites_filtro.min_lance_03 !== null ? `${limites_filtro.min_lance_03}%` : '-' }}</p>
                <p style="width: 20px">{{ limites_filtro.max_lance_03 !== null ? `${limites_filtro.max_lance_03}%` : '-' }}</p>
            </div>
            <p class="text--darkgray">Média lance total</p>
            <v-range-slider v-model="filtro_detalhado.range_lance_total" :min="limites_filtro.min_lance_total"
                            :max="limites_filtro.max_lance_total" :step="1" color="secondary" track-color="gray" track-fill-color="secondary"
                            :disabled="limites_filtro.min_lance_total === null || limites_filtro.max_lance_total === null">
                <template v-slot:thumb-label="param">
                    <span>{{ param.value }}%</span>
                </template>
            </v-range-slider>
            <div class="d-flex justify-space-between">
                <p style="width: 20px">
                    {{ limites_filtro.min_lance_total !== null ? `${limites_filtro.min_lance_total}%` : '-' }}
                </p>
                <p style="width: 20px">
                    {{ limites_filtro.max_lance_total !== null ? `${limites_filtro.max_lance_total}%` : '-' }}
                </p>
            </div>

            <v-select id="FieldTipoGrupo" label="Aumento de Crédito " outlined v-model="filtro_detalhado.aumento_credito"
                      placeholder="Aumento de Crédito" :items="aumento_credito_filtro" item-text="value" item-value="value" />
            <br>

            <v-row class="align-center">
                <v-col>
                    <MoneyTextField label="Lance Livre:" placeholder="Valor mínimo" v-model="filtro_detalhado.range_lance_livre[0]"
                                    maxlength="11" outlined :options="{
                                        locale: 'pt-BR',
                                        suffix: '%',
                                        precision: 0,
                                        prefix: '',
                                    }" maxvalue="100" />
                </v-col>
                <p class="mb-0">a</p>
                <v-col>
                    <MoneyTextField placeholder="Valor máximo" v-model="filtro_detalhado.range_lance_livre[1]" maxlength="11"
                                    outlined :options="{
                                        locale: 'pt-BR',
                                        suffix: '%',
                                        precision: 0,
                                        prefix: '',
                                    }" maxvalue="100" />
                </v-col>
            </v-row>

            <v-row class="align-center">
                <v-col>
                    <MoneyTextField label="Lance Fixo:" placeholder="Valor mínimo" v-model="filtro_detalhado.range_lance_fixo[0]"
                                    maxlength="11" outlined :options="{
                                        locale: 'pt-BR',
                                        suffix: '%',
                                        precision: 0,
                                        prefix: '',
                                    }" maxvalue="100" />
                </v-col>
                <p class="mb-0">a</p>
                <v-col>
                    <MoneyTextField placeholder="Valor máximo" v-model="filtro_detalhado.range_lance_fixo[1]" maxlength="11"
                                    outlined :options="{
                                        locale: 'pt-BR',
                                        suffix: '%',
                                        precision: 0,
                                        prefix: '',
                                    }" maxvalue="100" />
                </v-col>
            </v-row>

            <div slot="footer" class="d-flex row-padding">
                <v-flex class="col flex-basis-0">
                    <v-btn color="secondary" block @click="limparFiltroDetalhado">Limpar Filtros</v-btn>
                </v-flex>
                <v-flex class="col flex-basis-0">
                    <v-btn color="primary" block @click="aplicarFiltroDetalhado">Filtrar</v-btn>
                </v-flex>
            </div>
        </TabDialog>
        <TabDialog title="Alterar Visualização" v-model="aba_visualizacao_visivel">
            <p class="text--dark my-4">Selecione abaixo as colunas que deseja visualizar na listagem de Políticas de Vendas:</p>
            <v-checkbox v-model="campos_alterar_visualizacao.num_maximo_cotas" label="Número Máximo de Cotas" />
            <v-checkbox v-model="campos_alterar_visualizacao.vagas" label="Vagas" />
            <v-checkbox v-model="campos_alterar_visualizacao.assembleias_realizadas" label="Assembleias Realizadas" />
            <v-checkbox v-model="campos_alterar_visualizacao.credito_menor" label="Crédito Menor" />
            <v-checkbox v-model="campos_alterar_visualizacao.credito_maior" label="Crédito Maior" />
            <v-checkbox v-model="campos_alterar_visualizacao.categoria" label="Categoria Plano de Venda (Linear / Degrau)" />
            <v-checkbox v-model="campos_alterar_visualizacao.lc_embutido" label="Lance Embutido" />
            <v-checkbox v-model="campos_alterar_visualizacao.lc_parcelado" label="Lance Parcelado" />
            <v-checkbox v-model="campos_alterar_visualizacao.md_contemplacao" label="Média Contemplações por lance" />
            <v-checkbox v-model="campos_alterar_visualizacao.lance_01" label="Último menor lance" />
            <v-checkbox v-model="campos_alterar_visualizacao.lance_02" label="Penúltimo menor lancer" />
            <v-checkbox v-model="campos_alterar_visualizacao.lance_03" label="Antepenúltimo menor lance" />
            <v-checkbox v-model="campos_alterar_visualizacao.lance_total" label="Média lance total" />
            <v-checkbox v-model="campos_alterar_visualizacao.lance_fixo" label="Diluição de Lance Fixo" />
            <v-checkbox v-model="campos_alterar_visualizacao.lance_livre" label="Diluição de Lance Livre" />
            <v-checkbox v-model="campos_alterar_visualizacao.aumento_credito" label="Aumento de Crédito" />

            <div slot="footer" class="d-flex row-padding">
                <v-flex class="col flex-basis-0">
                    <v-btn color="secondary" block @click="restaurarVisualizacao">Restaurar Configurações</v-btn>
                </v-flex>
                <v-flex class="col flex-basis-0">
                    <v-btn color="primary" block @click="aplicarAlteracoesVisualizacao">Aplicar</v-btn>
                </v-flex>
            </div>
        </TabDialog>

        <!-- Esse dialog tem um v-if para evitar que no conteúdo dele seja tentado renderizar as props do objeto enquanto ele ainda está null -->
        <Dialog v-if="condicao_selecionada !== null" v-model="dialog_prosseguir_visivel"
                :title="`GRUPO: ${condicao_selecionada.cd_grupo} - PLANO DE VENDA: ${condicao_selecionada.cd_plano_venda + ' - ' + condicao_selecionada.nm_plano_venda}`"
                show-close-button>
            <v-layout class="justify-center">
                <v-col cols="6">
                    <v-btn block color="primary" :disabled="verificaPrazos" @click="avancar()">Prosseguir com venda</v-btn>
                </v-col>
            </v-layout>
        </Dialog>
    </v-container>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import CardProduto from '@/components/CardProduto'
  import MSwiper from '@/components/MSwiper'
  import { colorRes } from '@/plugins/flavors'
  import TabDialog from '@/components/TabDialog'
  import { alert, notification, pegaNumeroAteSegundaVirgula } from '@/plugins/helpers'
  import iconNotFound from '@/components/custom-icons/iconNotFound'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { TiposGrupo } from '@/plugins/constants'
  import StepperPoliticaVendas from '../../components/politica-vendas/StepperPoliticaVendas.vue'
  import Color from 'color'
  import conferirIntegridadeIniciarVenda from '../../mixins/CommercialHierarchy/conferirIntegridadeIniciarVenda'
  import { AlertTypes } from '../../plugins/alerts_types'
  export default {
    name: 'TabelaPoliticaVendas',
    components: { TabDialog, MSwiper, CardProduto, iconNotFound, StepperPoliticaVendas },
    directives: {
      resize: {
        inserted (el, binding) {
          const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
              binding.value(entry.target)
            }
          })
          resizeObserver.observe(el)
        }
      }
    },
    mixins: [conferirIntegridadeIniciarVenda],
    data: () => ({
      estilosScrollBar: {
        '--marginScrollLeft': 0
      },
      post_filial_escolhida: Function,
      modalidades: [],
      modalidade_selecionada_index: null,
      filtro: {
        id_grupo: null,
        id_plano_venda: null,
        id_produto: null,
        range_valor_parcela: [null, null],
        range_valor_credito: [null, null],
        range_prazos: [null, null],
        range_assembleias: [null, null],
        range_lc_embutido: [null, null],
        range_lc_parcelado: [null, null],
        range_md_contemplacao: [null, null],
        range_lance_01: [null, null],
        range_lance_02: [null, null],
        range_lance_03: [null, null],
        range_lance_total: [null, null],
        tipo_grupo: null,
        aumento_credito: 'Todos',
        range_lance_livre: [null, null],
        range_lance_fixo: [null, null]
      },
      politica_vendas: [],
      grupos: [],
      planos_venda: [],
      campos_usuario: {
        num_maximo_cotas: true,
        vagas: true,
        assembleias_realizadas: true,
        credito_menor: true,
        credito_maior: true,
        categoria: true,
        lc_embutido: true,
        lc_parcelado: true,
        md_contemplacao: true,
        lance_01: true,
        lance_02: true,
        lance_03: true,
        lance_total: true,
        aumento_credito: true,
        lance_fixo: true,
        lance_livre: true
      },
      prazos: [],
      // Crio esse segundo model pq o requisito diz que deve aplicar as mudanças apenas
      // no clique do botão. Então armazeno a alteração do usuário aqui e depois seto
      // no model que manipula a visualização
      campos_alterar_visualizacao: {
        num_maximo_cotas: true,
        vagas: true,
        assembleias_realizadas: true,
        credito_menor: true,
        credito_maior: true,
        categoria: true,
        lc_embutido: true,
        lc_parcelado: true,
        md_contemplacao: true,
        lance_01: true,
        lance_02: true,
        lance_03: true,
        lance_total: true,
        aumento_credito: true,
        lance_fixo: true,
        lance_livre: true
      },
      aba_bem_visivel: false,
      aba_filtro_visivel: false,
      aba_visualizacao_visivel: false,
      filtro_detalhado: {
        id_produto: null,
        range_valor_parcela: [null, null],
        range_valor_credito: [null, null],
        range_prazos: [0, 0],
        range_assembleias: [0, 0],
        range_lc_embutido: [0, 0],
        range_lc_parcelado: [0, 0],
        range_md_contemplacao: [0, 0],
        range_lance_01: [0, 0],
        range_lance_02: [0, 0],
        range_lance_03: [0, 0],
        range_lance_total: [0, 0],
        range_lance_livre: [null, null],
        range_lance_fixo: [null, null],
        tipo_grupo: '',
        aumento_credito: 'Todos'
      },
      limites_filtro: {
        max_assembleias_realizadas: 0,
        max_prazos: 0,
        min_assembleias_realizadas: 0,
        min_prazos: 0,
        max_lc_embutido: 0,
        min_lc_embutido: 0,
        max_lc_parcelado: 0,
        min_lc_parcelado: 0,
        max_md_contemplacao: 0,
        min_md_contemplacao: 0,
        max_lance_01: 0,
        min_lance_01: 0,
        max_lance_02: 0,
        min_lance_02: 0,
        max_lance_03: 0,
        min_lance_03: 0,
        max_lance_total: 0,
        min_lance_total: 0
      },
      bemEPrazoSelecionado: {
        id_bem: null,
        pz_comercializacao: null,
        st_tipo_venda: null,
        vl_bem: null,
        vl_parcela: null,
        nm_bem: null
      },
      bens: [],
      filtro_bens: {
        texto: null,
        vl_bem_min: null,
        vl_bem_max: null
      },
      bem_selecionado: null,
      dialog_prosseguir_visivel: false,
      condicao_selecionada: null,
      verificaPrazos: true,
      id_reserva: null,
      item_da_reserva_para_ser_focado: null,
      permite_flavor_todos_produtos: false,
      tipos_grupos: [TiposGrupo.GrupoPontual, TiposGrupo.GrupoConvencional, TiposGrupo.GrupoPraJa, 'Todos'],
      aumento_credito_filtro: ['Sim', 'Não', 'Todos']
    }),
    computed: {
      cssProps () {
        return {
          '--secondaryTransparent': Color(colorRes().secondary).alpha(0.15),
          '--primaryTransparent': Color(colorRes().primary).alpha(0.15),
          ...this.estilosScrollBar
        }
      },
      ...mapGetters([
        'modalidadesEmpresa',
        'dadosRestricaoVenda'
      ]),
      ...mapState(['jornada_venda']),
      tem_modalidade_selecionada () { return this.modalidade_selecionada_index !== null },
      headers: () => ([
        { text: 'Grupo', value: 'cd_grupo' },
        { text: 'Plano de Venda', value: 'nm_plano_venda' },
        { text: 'Número Máximo de Cotas', value: 'num_maximo_cotas' },
        { text: 'Vagas', value: 'vagas' },
        { text: 'PRAZOS', value: 'prazos' },
        { text: 'Assembleias Realizadas', value: 'assembleias_realizadas' },
        { text: 'Crédito Menor', value: 'credito_menor' },
        { text: 'Crédito Maior', value: 'credito_maior' },
        { text: 'Categoria Plano de Venda (Linear / Degrau)', value: 'categoria' }
      ]),
      params () {
        const ambientes = this.$session.get('ambiente')
        const unidadeCondicoesVenda = ambientes && ambientes.unidade_condicoes_venda

        return {
          pagination: { rowsPerPage: 15, items_grid: 15 },
          range_valor_parcela: this.filtro.range_valor_parcela,
          range_valor_credito: this.filtro.range_valor_credito,
          range_prazos: this.filtro.range_prazos,
          range_assembleias: this.filtro.range_assembleias,
          range_lc_embutido: this.filtro.range_lc_embutido,
          range_lc_parcelado: this.filtro.range_lc_parcelado,
          range_md_contemplacao: this.filtro.range_md_contemplacao,
          range_lance_01: this.filtro.range_lance_01,
          range_lance_02: this.filtro.range_lance_02,
          range_lance_03: this.filtro.range_lance_03,
          range_lance_total: this.filtro.range_lance_total,
          id_bem: this.bem_selecionado ? this.bem_selecionado.id_bem : null,
          id_empresa: this.$session.get('id_empresa'),
          permiti_venda_todas_empresas: this.permite_flavor_todos_produtos,
          tipo_grupo: this.filtro.tipo_grupo,
          aumento_credito: this.filtro.aumento_credito,
          range_lance_fixo: this.filtro.range_lance_fixo,
          range_lance_livre: this.filtro.range_lance_livre,
          dadosRestricaoVenda: this.dadosRestricaoVenda,
          id_unidade_negocio: this.$session.get('id_unidade_negocio'),
          id_ponto_venda: this.$session.get('id_ponto_venda'),
          flavor: this.$session.get('flavor'),
          ...(unidadeCondicoesVenda && { unidade_condicoes_venda: unidadeCondicoesVenda })
        }
      },
      filter () {
        return {
          id_produto: this.filtro.id_produto !== null && typeof this.filtro.id_produto !== 'undefined' ? [this.filtro.id_produto] : this.ids_produtos,
          id_grupo: this.filtro.id_grupo,
          id_plano_venda: this.filtro.id_plano_venda
        }
      },
      ids_produtos () {
        return this.modalidades[this.modalidade_selecionada_index].produtos.map(produto => produto.id_produto)
      },
      cds_produtos () {
        return this.modalidades[this.modalidade_selecionada_index].produtos.map(produto => produto.cd_produto)
      },
      modalidade_selecionada () {
        return this.modalidades[this.modalidade_selecionada_index]
      },
      exibir_colunas_calculo_lance () {
        return this.campos_usuario.lance_01 ||
          this.campos_usuario.lance_02 ||
          this.campos_usuario.lance_03 ||
          this.campos_usuario.lance_total
      },
      exibir_colunas_diluicao_lance () {
        return this.campos_usuario.lance_fixo || this.campos_usuario.lance_livre
      }
    },
    watch: {
      aba_filtro_visivel (show) {
        this.$refs.TabDialog.TravarScroll(show)
      },
      aba_visualizacao_visivel (show) {
        if (show) {
          Object.assign(this.campos_alterar_visualizacao, this.campos_usuario)
        }
        this.$refs.TabDialog.TravarScroll(show)
      },
      aba_bem_visivel (show) {
        if (!show) {
          this.filtro_bens = {
            texto: null,
            vl_bem_min: null,
            vl_bem_max: null
          }
        }
        this.$refs.TabDialog.TravarScroll(show)
      },
      dialog_prosseguir_visivel (show) {
        if (!show) {
          this.condicao_selecionada = null
        }
        this.verificaPrazo()
      },
      'filtro.id_grupo' (id_grupo) {
        if (!id_grupo) {
          this.limparFiltroDetalhado()
        }
      },
      'filtro.id_plano_venda' (id_plano_venda) {
        if (!id_plano_venda) {
          this.limparFiltroDetalhado()
        }
      }
    },
    async mounted () {
      this.$refs.TabDialog.TravarScroll(false)
      this.verificarSePodeProsseguirVenda()
      this.permite_flavor_todos_produtos = this.$session.get('permite_venda_todos_produtos')

      this.carregarModalidades()
        .then(() => {
          if (this.$route.params.id_reserva) {
            this.id_reserva = this.$route.params.id_reserva
          }
          if (this.$route.params.filtro) {
            this.selecionarModalidade(this.$route.params.modalidade_selecionada_index)
            this.item_da_reserva_para_ser_focado = this.$route.params.modalidade_selecionada_index
            Object.assign(this.filtro, this.$route.params.filtro)
          }

          if (this.$route.params.bem_selecionado_tabela && this.$route.params.bem_selecionado_tabela.id_bem > 0) {
            this.bem_selecionado = this.$route.params.bem_selecionado_tabela
            this.carregarBens()
            this.selecionarBem(this.bem_selecionado)
          }
        })

      this.carregarCamposUsuario()
    },
    methods: {
      ajustarTamanhosResponsivos (target) {
        const headerElementosFixados = document.querySelector('.fixed-column-table-head')

        if (headerElementosFixados) {
          const widthElementosFixados = headerElementosFixados.offsetWidth
          this.estilosScrollBar['--marginScrollLeft'] = widthElementosFixados + 'px'
        }
      },
      pegaNumeroAteSegundaVirgula (numero) {
        return pegaNumeroAteSegundaVirgula(numero)
      },
      trazerAssembleiasRealizadas (tipoDeGrupo, assembleiasRealizadas) {
        return (tipoDeGrupo === null || tipoDeGrupo === undefined) ? (assembleiasRealizadas !== 0 ? assembleiasRealizadas : null) : (tipoDeGrupo === 'F' ? null : assembleiasRealizadas)
      },
      calcularMediaLance (lance1, lance2, lance3) {
        lance1 = lance1 < 0 ? 0 : lance1 ?? 0
        lance2 = lance2 < 0 ? 0 : lance2 ?? 0
        lance3 = lance3 < 0 ? 0 : lance3 ?? 0

        const numerosParaUsarNoCalculo = []

        if (lance1 > 0 && typeof lance1 === 'number') { numerosParaUsarNoCalculo.push(lance1) }
        if (lance2 > 0 && typeof lance2 === 'number') { numerosParaUsarNoCalculo.push(lance2) }
        if (lance3 > 0 && typeof lance3 === 'number') { numerosParaUsarNoCalculo.push(lance3) }

        return numerosParaUsarNoCalculo.reduce((acumulado, valorNovo) => acumulado + valorNovo, 0) / numerosParaUsarNoCalculo.length
      },
      async carregarModalidades () {
        this.modalidades = await this.modalidadesEmpresa
      },
      async carregarGrupos () {
        try {
          const id_unidade_negocio = this.$session.get('id_unidade_negocio')
          const id_ponto_venda = this.$session.get('id_ponto_venda')
          const flavor = this.$session.get('flavor')
          const ambientes = this.$session.get('ambiente')
          const unidadeCondicoesVenda = ambientes && ambientes.unidade_condicoes_venda
          const res = await this.$http.get('/politica_vendas/grupos', {
            params: {
              id_produto: this.ids_produtos,
              id_empresa: this.$session.get('id_empresa'),
              permite_flavor_todos_produtos: this.permite_flavor_todos_produtos,
              tipo_grupo: this.filtro_detalhado.tipo_grupo,
              dadosRestricaoVenda: this.dadosRestricaoVenda,
              id_unidade_negocio,
              id_ponto_venda,
              flavor,
              ...(unidadeCondicoesVenda && { unidade_condicoes_venda: unidadeCondicoesVenda })
            }
          })
          this.grupos = res.data
        } catch (e) {
          notification('error', e, 'Não foi possível carregar os grupos do filtro')
        }
      },
      async carregarPlanosVenda () {
        try {
          const id_empresa = this.$session.get('id_empresa')
          const ambientes = this.$session.get('ambiente')
          const unidadeCondicoesVenda = ambientes && ambientes.unidade_condicoes_venda

          await this.$http.get('/politica_vendas/planos', {
            params: {
              id_produto: this.ids_produtos,
              dadosRestricaoVenda: this.dadosRestricaoVenda,
              id_empresa: id_empresa,
              ...(unidadeCondicoesVenda && { unidade_condicoes_venda: unidadeCondicoesVenda })
            }
          }).then((res) => {
            this.planos_venda = res.data
          })
        } catch (e) {
          notification('error', e, 'Não foi possível carregar os planos de venda do filtro')
        }
      },
      async carregarCamposUsuario () {
        try {
          const res = await this.$http.get('/politica_vendas/campos_usuario', { options: { silent: true } })
          Object.assign(this.campos_usuario, res.data)
        } catch (e) {
          notification('error', e, 'Não foi possível carregar a configuração de campos da tabela')
        }
      },
      async carregarPrazos () {
        try {
          const res = await this.$http.get('/politica_vendas/prazos', {
            params: {
              id_produto: this.filter.id_produto
            }
          })
          this.prazos = res.data
        } catch (e) {
          notification('error', e, 'Não foi possível os prazos')
        }
      },

      async carregarLimitesFiltroPrazoComercializacaoEAssembleia () {
        try {
          const res = await this.$http.get('/politica_vendas/limites_filtro', {
            params: {
              id_produto: this.ids_produtos,
              id_grupo: this.filtro.id_grupo,
              id_plano_venda: this.filtro.id_plano_venda
            }
          })
          return res.data
        } catch (e) {
          notification('error', e, 'Não foi possível carregar os dados do filtro')
          return null
        }
      },
      async carregarBens (id_grupo = false, id_plano_venda = false) {
        try {
          id_grupo = id_grupo || this.filter.id_grupo
          id_plano_venda = id_plano_venda || this.filter.id_plano_venda

          const res = await this.$http.get('/politica_vendas/bens', {
            params: {
              ...this.filter,
              ...this.filtro_bens,
              id_grupo,
              id_plano_venda
            }
          })
          return res.data
        } catch (e) {
          notification('error', e, 'Não foi possível carregar os bens')
        }
      },
      getFuroDoPrazoOuRetornaTraco (prazos, prazo) {
        return prazos
          .filter(item => parseInt(item.prazo) === prazo)
          .map(item => item.furo)[0] || '-'
      },
      async selecionarModalidade (modalidade_selecionada) {
        this.modalidade_selecionada_index = modalidade_selecionada
        this.bem_selecionado = null
        this.filtro.id_grupo = null
        this.filtro.id_plano_venda = null
        this.filtro.id_produto = null
        this.limparFiltroDetalhado()
        this.carregarGrupos()
        this.carregarPlanosVenda()

        this.limites_filtro = await this.carregarLimitesFiltroPrazoComercializacaoEAssembleia()
      },
      itensCarregados (items) {
        this.politica_vendas = items
        if ((!items || items.length === 0) && this.temFiltrosEspecificos()) {
          notification(AlertTypes.ERROR, 'Nenhum grupo/plano encontrado para as condições selecionadas.')
        }
        this.carregarPrazos()
      },
      aplicarAlteracoesVisualizacao () {
        sendAnalyticsEvent(this.$gtag, 'politica_venda_visualizacao', {
          politica_selecionada: this.comeValuesTrue(this.campos_alterar_visualizacao).join(', '),
          source_menu: this.jornada_venda
        })
        Object.assign(this.campos_usuario, this.campos_alterar_visualizacao)
        this.aba_visualizacao_visivel = false
        this.salvarConfiguracaoCampos()
      },
      temFiltrosEspecificos () {
        return this.filter?.id_grupo || this.filter?.id_plano_venda
      },
      comeValuesTrue (campos) {
        const camposAtivos = []
        for (const chave in campos) {
          if (campos[chave]) {
            camposAtivos.push(chave)
          }
        }
        return camposAtivos
      },
      restaurarVisualizacao () {
        Object.keys(this.campos_usuario).forEach((key) => {
          this.campos_usuario[key] = true
          this.aba_visualizacao_visivel = false
        })
        this.salvarConfiguracaoCampos()
      },
      salvarConfiguracaoCampos () {
        this.$http.post('/politica_vendas/campos_usuario', this.campos_usuario, { options: { silent: true } })
      },
      async abrirFiltro () {
        const limites_filtro = this.limites_filtro
        if (limites_filtro) {
          this.limites_filtro = limites_filtro
          this.filtro_detalhado.range_valor_parcela[0] = this.filtro.range_valor_parcela[0]
          this.filtro_detalhado.range_valor_parcela[1] = this.filtro.range_valor_parcela[1]
          this.filtro_detalhado.range_valor_credito[0] = this.filtro.range_valor_credito[0]
          this.filtro_detalhado.range_valor_credito[1] = this.filtro.range_valor_credito[1]
          this.filtro_detalhado.range_lance_livre[0] = this.filtro.range_lance_livre[0]
          this.filtro_detalhado.range_lance_livre[1] = this.filtro.range_lance_livre[1]
          this.filtro_detalhado.range_lance_fixo[0] = this.filtro.range_lance_fixo[0]
          this.filtro_detalhado.range_lance_fixo[1] = this.filtro.range_lance_fixo[1]
          this.filtro_detalhado.range_assembleias = this.filtro.range_assembleias
          this.filtro_detalhado.range_prazos = this.filtro.range_prazos
          this.filtro_detalhado.id_produto = this.filtro.id_produto
          this.filtro_detalhado.tipo_grupo = this.filtro.tipo_grupo
          this.filtro_detalhado.aumento_credito = this.filtro.aumento_credito

          const setaValoresDefaultSeVazio = (model, min_key, max_key) => {
            const limiteMinimo = limites_filtro[min_key]
            const limiteMaximo = limites_filtro[max_key]

            const limiteIsNotNull = (limiteMinimo !== null && limiteMaximo !== null)
            const limiteMinimoIsInvalid = (this.filtro[model][0] === null || this.filtro[model][0] < limiteMinimo)
            const limiteMaximoIsInvalid = (this.filtro[model][1] === null || this.filtro[model][1] > limiteMaximo)

            if (limiteIsNotNull) {
              if (limiteMinimoIsInvalid) {
                this.filtro_detalhado[model][0] = limiteMinimo
              }
              if (limiteMaximoIsInvalid) {
                this.filtro_detalhado[model][1] = limiteMaximo
              }
              this.filtro_detalhado[model] = [...this.filtro_detalhado[model]]
            }
          }

          const filtersAreEmpty = (this.filtro.range_prazos[0] === null && this.filtro.range_prazos[1] === null)
          if (filtersAreEmpty) {
            this.filtro_detalhado.range_prazos = [limites_filtro.min_prazos, limites_filtro.max_prazos]
          }
          setaValoresDefaultSeVazio('range_assembleias', 'min_assembleias_realizadas', 'max_assembleias_realizadas')
          setaValoresDefaultSeVazio('range_lc_embutido', 'min_lc_embutido', 'max_lc_embutido')
          setaValoresDefaultSeVazio('range_lc_parcelado', 'min_lc_parcelado', 'max_lc_parcelado')
          setaValoresDefaultSeVazio('range_md_contemplacao', 'min_md_contemplacao', 'max_md_contemplacao')
          setaValoresDefaultSeVazio('range_lance_01', 'min_lance_01', 'max_lance_01')
          setaValoresDefaultSeVazio('range_lance_02', 'min_lance_02', 'max_lance_02')
          setaValoresDefaultSeVazio('range_lance_03', 'min_lance_03', 'max_lance_03')
          setaValoresDefaultSeVazio('range_lance_total', 'min_lance_total', 'max_lance_total')

          this.aba_filtro_visivel = true
        }
      },
      async abrirAbaBens (id_grupo = false, id_plano_venda = false) {
        sendAnalyticsEvent(this.$gtag, 'politica_venda_selecionarBem', {
          grupo: this.grupos.find(grupo => grupo.id_grupo === this.filtro.id_grupo)?.cd_grupo ?? '',
          plano_venda: this.getPlanoVendaNome(this.filtro.id_plano_venda) ?? '',
          tipo_produto: this.modalidade_selecionada,
          source_menu: this.jornada_venda
        })
        if (!(id_grupo > 0) || !(id_plano_venda > 0)) {
          if (!this.$refs.formPoliticaVenda.validate()) {
            return
          }
          id_grupo = this.filter.id_grupo
          id_plano_venda = this.filter.id_plano_venda
          const condicao_venda = this.politica_vendas.find(politica => (politica.id_grupo === id_grupo) && (politica.id_plano_venda === id_plano_venda))
          if (!condicao_venda) {
            notification(AlertTypes.WARN, 'Não há condição de venda para os grupo e plano de venda selecionados, portanto não é possível selecionar o bem.')
            return
          }
          this.condicao_selecionada = condicao_venda
        }
        const bens = await this.carregarBens(id_grupo, id_plano_venda)
        if (bens) {
          this.bens = bens
          this.aba_bem_visivel = true
        }
      },
      limparFiltroBens () {
        this.filtro_bens = {
          texto: null,
          vl_bem_min: null,
          vl_bem_max: null
        }
        this.abrirAbaBens()
      },
      selecionarBem (bem) {
        this.bem_selecionado = bem
        this.aba_bem_visivel = false

        this.avancar()
      },
      atualizarFiltro (filtro, filtroDetalhado) {
        return {
          ...filtro,
          id_produto: filtroDetalhado.id_produto,
          range_valor_parcela: [...filtroDetalhado.range_valor_parcela],
          range_valor_credito: [...filtroDetalhado.range_valor_credito],
          range_prazos: [...filtroDetalhado.range_prazos],
          range_assembleias: [...filtroDetalhado.range_assembleias],
          range_lc_embutido: [...filtroDetalhado.range_lc_embutido],
          range_lc_parcelado: [...filtroDetalhado.range_lc_parcelado],
          range_md_contemplacao: [...filtroDetalhado.range_md_contemplacao],
          range_lance_01: [...filtroDetalhado.range_lance_01],
          range_lance_02: [...filtroDetalhado.range_lance_02],
          range_lance_03: [...filtroDetalhado.range_lance_03],
          range_lance_total: [...filtroDetalhado.range_lance_total],
          range_lance_livre: [...filtroDetalhado.range_lance_livre],
          range_lance_fixo: [...filtroDetalhado.range_lance_fixo],
          tipo_grupo: filtroDetalhado.tipo_grupo,
          aumento_credito: filtroDetalhado.aumento_credito
        }
      },
      async aplicarFiltroDetalhado () {
        this.filtro = this.atualizarFiltro(this.filtro, this.filtro_detalhado)

        this.aba_filtro_visivel = false

        const opcao_produto = this.filtro_detalhado.id_produto ? this.getNomeProdutoFromSelectedModalidade(this.filtro_detalhado.id_produto) : this.getNomeTodosProdutos()
        sendAnalyticsEvent(this.$gtag, 'politica_venda_filtro', {
          tipo_produto: this.modalidade_selecionada.nome,
          opcao_produto,
          source_menu: this.jornada_venda
        })
      },
      getPlanoVendaNome (id_plano_venda) {
        const plano = this.planos_venda.find(plano => plano.id_plano_venda === id_plano_venda)
        return plano ? plano.cd_nm_plano_venda : ''
      },
      getNomeTodosProdutos () {
        return this.modalidade_selecionada.produtos.map(produto => produto.nome_produto).join(', ')
      },
      getNomeProdutoFromSelectedModalidade (id_produto) {
        return this.modalidade_selecionada.produtos.find(produto => produto.id_produto === id_produto).nome_produto
      },
      limparFiltroDetalhado () {
        Object.assign(this.filtro, {
          id_produto: null,
          range_valor_parcela: [null, null],
          range_valor_credito: [null, null],
          range_prazos: [null, null],
          range_assembleias: [null, null],
          range_lc_embutido: [null, null],
          range_lc_parcelado: [null, null],
          range_md_contemplacao: [null, null],
          range_lance_01: [null, null],
          range_lance_02: [null, null],
          range_lance_03: [null, null],
          range_lance_total: [null, null],
          range_lance_fixo: [null, null],
          range_lance_livre: [null, null],
          tipo_grupo: null,
          aumento_credito: 'Todos'
        })

        this.$nextTick(() => {
          this.$refs.datatable.reload()
        })
        this.aba_filtro_visivel = false
      },
      async handleRowSelected (condicao_venda) {
        this.condicao_selecionada = condicao_venda
        if (this.isGrupoEmFormacao(condicao_venda)) {
          await this.abrirAbaBens(condicao_venda.id_grupo, condicao_venda.id_plano_venda)
        } else {
          this.abrirDialogProsseguir()
        }
      },
      isGrupoEmFormacao (condicao_venda) {
        return condicao_venda.st_situacao === 'F'
      },
      async abrirDialogProsseguir () {
        this.dialog_prosseguir_visivel = true
      },
      avancar () {
        sendAnalyticsEvent(this.$gtag, 'politica_venda_prosseguirVenda', {
          grupo: this.condicao_selecionada.cd_grupo,
          plano_venda: `${this.condicao_selecionada.cd_plano_venda} - ${this.condicao_selecionada.nm_plano_venda}`,
          tipo_produto: this.modalidade_selecionada.nome,
          source_menu: this.jornada_venda
        })

        const ids_produtos = this.modalidade_selecionada.produtos.map(produto => produto.id_produto)

        this.$router.push({
          name: 'selecionar-bem-politica-vendas',
          params: {
            ...this.condicao_selecionada,
            id_bem: this.bem_selecionado ? this.bem_selecionado.id_bem : null,
            cd_bem: this.bem_selecionado ? this.bem_selecionado.cd_bem : null,
            id_reserva: this.id_reserva,
            modalidades: this.modalidades,
            modalidade_selecionada_index: this.modalidade_selecionada_index,
            filtro: this.filtro,
            cd_produto: this.cds_produtos,
            bem_selecionado_tabela: this.bem_selecionado,
            produtos: ids_produtos
          }
        })
      },
      verificaPrazo () {
        let dados = this.condicao_selecionada.prazos ? this.condicao_selecionada.prazos : []
        if (dados) {
          const result = dados.filter(item => item.furo > 0 && item.furo !== 'NÃO' && item.furo !== '-')
          if (result.length) {
            this.verificaPrazos = false
          } else {
            this.verificaPrazos = true
          }
        }
      },
      confirmReload (next) {
        alert({
          text: 'Tem certeza que deseja sair? Você perderá mudanças não salvas!',
          buttons: {
            'Cancelar': () => next(false),
            'Confirmar': () => next()
          }
        })
      }
    },
    beforeRouteLeave (to, from, next) {
      if (!from.name) {
        this.confirmReload(next)
      } else if (to.name === 'logout' || !(this.is_usuario_logado_hierarquia && to.query.redirecionamentoPainelLateral)) {
        next()
      } else {
        this.confirmReload(next)
      }
    }
  }

</script>

<style lang="scss" scoped>
h2 {
  font-size: 14px;
  color: var(--primary);
}

.header-line-fixed {
  z-index: 2;
  position: sticky;
  background-color: var(--darkwhite);
  top: -1px;
}

.card-container {
  padding: 16px 24px;
  padding-top: 0px;
}

.card-produto {
  opacity: 0.5;
  border: 4px solid transparent;
  border-radius: 10px;
  padding: 4px;
}

.card-produto.card-selecionado {
  opacity: 1;
  border-color: var(--secondary);
}

.prazo-header {
  width: 60px;
}

.sub-header {
  text-align: center;
  font-weight: normal;
  margin: 10px 0 0;
}

.td-spacer {
  font-size: 12px;
  z-index: -1;
  height: 0;
  opacity: 0;
}

.prazo-sim {
  color: var(--secondary);
  font-weight: 600;

}

 /* Cuidado ao modificar os estilos !! */
.table-politica-vendas {

  th,
  td {
    white-space: nowrap;
  }

  .v-data-table__wrapper {
    background-color: var(--darkwhite);
  }

  thead {
    background: var(--darkwhite);
  }

  ::-webkit-scrollbar {
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-track {
    background: var(--lightestgrey);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--primary);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  $espacamento_scrollbar_vertical_top_tela_grande: 5.2rem;
  $espacamento_scrollbar_horizontal_responsiva: var(--marginScrollLeft);

  ::-webkit-scrollbar-track:vertical {
    background-color: var(--darkwhite);
    z-index: 1;
    margin-top: $espacamento_scrollbar_vertical_top_tela_grande;
  }

  ::-webkit-scrollbar-track:horizontal {
    background-color: var(--darkwhite);
    margin-left: $espacamento_scrollbar_horizontal_responsiva;
  }

  ::-webkit-scrollbar:horizontal {
    border-left: $espacamento_scrollbar_horizontal_responsiva solid var(--white);
  }

  @media (max-width: 1366px) {
    $espacamento_scrollbar_vertical_top_tela_media: 5.2rem;

    ::-webkit-scrollbar-track:vertical {
      background-color: var(--darkwhite);
      z-index: 1;
      margin-top: $espacamento_scrollbar_vertical_top_tela_media;
    }

    ::-webkit-scrollbar-track:horizontal {
      background-color: var(--white);
      margin-left: $espacamento_scrollbar_horizontal_responsiva;
    }

    ::-webkit-scrollbar:horizontal {
      border-left: $espacamento_scrollbar_horizontal_responsiva solid var(--white);
    }

  }
}

.datatable.hide-separator tbody tr:hover {
  background: #F00 !important;
}

.tooltip-descricao {
  position: absolute;
  left: 0;
  top: 100%;
  padding: 5px 10px;
  max-width: initial;
  background: #fff;
  color: #444;
  opacity: 0;
  z-index: -1;
}

.tooltip-icon:hover .tooltip-descricao {
  opacity: 1;
  position: absolute;
  right: 0px;
  z-index: 0;
}

.to-right {
  right: 0px;
}

.coluna-plano-venda{
  margin-left:-1px;
}
.img-bem {
  width: 115px;
  height: 65px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
}

.bem-item {
  padding: 25px 0;
  border-top: 1px solid var(--gray);
  cursor: pointer;

  h3 {
    color: var(--dark);
    text-transform: uppercase;
  }

  h4 {
    color: var(--primary);
  }

  &:hover {
    background: var(--gray);
  }
}

.bem-selecionado-img {
  width: 100%;
  height: 145px;
  object-fit: contain;
  object-position: right;
}

.bem-selecionado {
  .bem-infos {
    flex-direction: column;
    justify-content: space-evenly;
  }

  h3 {
    font-size: 16px;
    color: var(--secondary);
    text-transform: uppercase;
  }

  .nome-bem {
    font-size: 18px;
    color: var(--dark);
    text-transform: uppercase;
  }

  .valor-bem {
    font-size: 18px;
    color: var(--primary);
    text-transform: uppercase;
    font-weight: bold;
  }
}

.fixed-column-table-head {
  position: sticky;
  background-color: var(--darkwhite);
}

.fixed-line-table-head {
  position: fixed;
  z-index: 999;
}

$borda_separadora_fixos_e_nao_fixos: 1px solid var(--border_gray);

.fixed-column,
.fixed-column-table-head {
  border-right: $borda_separadora_fixos_e_nao_fixos;
}

.fixed-column {
  position: sticky;

  background-color: inherit;
}
</style>

<style>
/* Define o tamanho do pai do datatable */
.table-politica-vendas .v-data-table__wrapper {
  max-height: 70vh;
  background-color: var(--darkwhite);
}

.table-politica-vendas table tr:last-child td {
  margin-bottom: 20px;
}
</style>
